<!-- 平台查看多控销售统计 -->
<template>
  <div class="plSalesStatistic">
    <!-- 平台查看多控销售统计 -->
    <PlSalesStatisticGrid :list="list"/>
    <!-- 平台查看多控销售统计标签页 -->
    <plSalesStatisticTabs ref="tabsRef" @search="handleSearch" @export="handleExport"/>
    <!-- 平台查看多控销售统计表格 -->
    <PlSalesStatisticTable ref="tableRef"/>
  </div>
</template>

<script>
import PlSalesStatisticGrid from './components/PlSalesStatisticGrid'
import PlSalesStatisticTabs from './components/PlSalesStatisticTabs'
import PlSalesStatisticTable from './components/PlSalesStatisticTable'
import {
  goodsStatisticsForPlatform,
  exportGoodsStatisticsExcelForPlatform
} from '@/api/saleRule/productLine'
export default {
  name: 'plSalesStatistic',
  components: {
    PlSalesStatisticGrid,
    PlSalesStatisticTabs,
    PlSalesStatisticTable
  },
  data() {
    return {
        list:[{
            name: '商品总销量',
            value: 0,   
            key: 'goodsNum',
            notice:'已结算状态订单的有效数据'
        },
        {
            name: '销售订单总数',
            value: 0,   
            key: 'orderNum'
        },
        {
            name: '总销售额(元)',
            value: 0,   
            key: 'orderAmt'
        },
        {
            name: '活跃业务员总数',
            value: 0,   
            key:'salesmanNum',
            notice:'一个月内活跃的业务员数量'
        },
        {
            name: '活跃客户总数',
            value: 0,   
            key: 'customerNum',
            notice:'一个月内活跃的客户数量'
        },
        {
            name: '销售覆盖行政区',
            value: 0,   
            key: 'districtNum'
        },
    ]
    }
  },
  created() {
    
  },
  mounted() {
    this.$refs.tableRef.publicGetData()
    this.handleSearch({})
  },
  methods: {
    async handleSearch(e){
        this.$refs.tableRef.publicGetData(e)
        const res = await goodsStatisticsForPlatform(e)
        if(res){
          const { customerNum,districtNum,goodsNum,orderAmt,orderNum,salesmanNum } = res
          this.list.forEach(item => {
            if(item.key === 'customerNum'){
              item.value = customerNum
            }else if(item.key === 'districtNum'){
              item.value = districtNum
            }else if(item.key === 'goodsNum'){
              item.value = goodsNum
            }else if(item.key === 'orderAmt'){
              item.value = orderAmt
            }else if(item.key === 'orderNum'){
              item.value = orderNum
            }else if(item.key ==='salesmanNum'){
              item.value = salesmanNum
            }
        })
      }
    },
    async handleExport(e){
      const response = await exportGoodsStatisticsExcelForPlatform(e)
      if(response){
        const blob = response.data
        const fileName = '商品销售统计.xlsx'
        const downloadLink = document.createElement('a')
        const href = window.URL.createObjectURL(blob) // 创建下载的链接
        downloadLink.href = href
        downloadLink.download = fileName // 下载后文件名
        document.body.appendChild(downloadLink)
        downloadLink.click()
        window.URL.revokeObjectURL(href) // 释放掉blob对象
        document.body.removeChild(downloadLink) // 下载完成移除元素
      }
    }
  }
}
</script>


<style scoped lang="scss">
.plSalesStatistic {
    overflow-y: auto;
    height: calc(100vh - 145px);
}
</style>